import React from "react";
import { Gavel } from "lucide-react";

/** Single judge's score card with 5 criterion cells + internal notes block. */
export default function JudgeScoreCard({ score }) {
  return (
    <div className="border border-white/10 p-3" data-testid={`score-${score.judge_id}-${score.round}`}>
      <div className="flex flex-wrap items-baseline justify-between gap-2 mb-2">
        <div className="font-display text-sm text-white">
          {score.judge_name || "—"}
          <span className="text-[10px] text-brand font-mono uppercase ml-1">R{score.round}</span>
        </div>
        <div className="font-mono text-xs text-gray-500">
          {score.scored_at ? new Date(score.scored_at).toLocaleString() : "—"}
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-2 mb-2">
        {["innovation", "impact", "feasibility", "execution", "presentation"].map((k) => (
          <div key={k} className="bg-white/[0.03] border border-white/5 px-2 py-1.5">
            <div className="text-[9px] font-mono uppercase tracking-widest text-gray-500">{k}</div>
            <div className="font-display text-base text-white">
              {score[`${k}_score`] ?? "—"}<span className="text-[10px] text-gray-500 font-mono ml-1">/10</span>
            </div>
          </div>
        ))}
      </div>
      {score.internal_notes && (
        <div className="mt-2 text-xs text-gray-300 bg-[#080C18] border-l-2 border-brand/40 p-2.5 select-text whitespace-pre-wrap">
          <span className="label-mono text-[9px] block mb-1">// internal notes</span>
          {score.internal_notes}
        </div>
      )}
    </div>
  );
}

export function JudgeScoresList({ scores }) {
  if (!scores || scores.length === 0) {
    return <div className="text-xs text-gray-500 py-4">No judge scores recorded yet.</div>;
  }
  return (
    <div data-testid="judge-scores-list">
      <div className="label-mono mb-2 flex items-center gap-2">
        <Gavel className="w-3.5 h-3.5 text-brand" /> Judge scores · {scores.length}
      </div>
      <div className="space-y-3">
        {scores.map((s) => <JudgeScoreCard key={`${s.judge_id}-${s.round}`} score={s} />)}
      </div>
    </div>
  );
}
